import { createContext, useCallback, useContext, useState } from "react";
import PayoutDetails from "@areas/reconciliation/displays/PayoutDetails";

const PayoutDrawerContext = createContext(null);

export const usePayoutDrawer = () =>
  useContext(PayoutDrawerContext) ?? { openPayout: () => {} };

// Mounts the payout detail drawer once, app-wide, so a payout notification can open the payout's
// detail over the current page instead of navigating to the reconciliation list.
export function PayoutDrawerProvider({ children }) {
  const [payoutId, setPayoutId] = useState(null);

  const openPayout = useCallback((id) => setPayoutId(id), []);

  return (
    <PayoutDrawerContext.Provider value={{ openPayout }}>
      {children}
      <PayoutDetails id={payoutId} onClose={() => setPayoutId(null)} />
    </PayoutDrawerContext.Provider>
  );
}
